﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/user/register";
const method = "GET";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface GetRegisterProps extends api.ApiHookBaseProps<
    unknown,
    accountModel.GetRegisterResponse,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useGetAccountRegister(
    props: GetRegisterProps
): [boolean, () => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        accountModel.GetRegisterResponse,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        accountModel.GetRegisterResponse,
        unknown
    >(apiParams);
    return [loading, () => invoker(apiParams.uri, undefined)];
}
